import * as tslib_1 from "tslib";
import LocalStorageCouponSessionHandler from './LocalStorageCouponSessionHandler';
import addMinutes from 'date-fns/add_minutes';
import addHours from 'date-fns/add_hours';
import isAfter from 'date-fns/is_after';
import { v4 as uuidv4 } from 'uuid';
import { settings, store } from '../../../index';
import CookieStorageCouponSessionHandler from './CookieStorageCouponSessionHandler';
var CouponsSession = /** @class */ (function () {
    function CouponsSession(couponSessionHandler) {
        this.couponSessionHandler = couponSessionHandler;
    }
    CouponsSession.getInstance = function (couponSessionHandlerName) {
        if (couponSessionHandlerName === void 0) { couponSessionHandlerName = 'LocalStorage'; }
        if (CouponsSession.couponSessions.has(couponSessionHandlerName)) {
            return new CouponsSession(CouponsSession.couponSessions.get(couponSessionHandlerName));
        }
        var couponSessionHandler;
        switch (couponSessionHandlerName) {
            case 'CookieStorage':
                couponSessionHandler = new CookieStorageCouponSessionHandler();
                break;
            case 'LocalStorage':
            default:
                couponSessionHandler = new LocalStorageCouponSessionHandler();
        }
        CouponsSession.couponSessions.set(couponSessionHandlerName, couponSessionHandler);
        return new CouponsSession(couponSessionHandler);
    };
    CouponsSession.prototype.saveCouponCodeIntoUserSession = function (couponReference, market, couponCode) {
        var sessionKey = CouponsSession.getKeyForCouponSessionObject(couponReference.couponName, market);
        var validUntil;
        if (couponReference.codeValidUntilCampaignEndDate) {
            validUntil = couponReference.endDate;
        }
        else {
            validUntil = addHours(Date.now(), couponReference.codeValidity);
            if (isAfter(validUntil, couponReference.endDate)) {
                validUntil = couponReference.endDate;
            }
        }
        var couponObject = {
            validUntil: validUntil,
            code: couponCode
        };
        this.couponSessionHandler.set(sessionKey, JSON.stringify(couponObject));
        return couponObject;
    };
    CouponsSession.getKeyForCouponSessionObject = function (couponName, market) {
        return 'coupon.v2.' + market + '.' + couponName;
    };
    CouponsSession.prototype.getCouponObjectFromUserSession = function (couponReference, market) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var sessionKey = CouponsSession.getKeyForCouponSessionObject(couponReference.couponName, market);
                        var couponObjectFromSessionStorage = _this.couponSessionHandler.has(sessionKey) ?
                            JSON.parse(_this.couponSessionHandler.get(sessionKey)) :
                            null;
                        if (couponObjectFromSessionStorage && isAfter(couponObjectFromSessionStorage.validUntil, new Date())) {
                            resolve(couponObjectFromSessionStorage);
                        }
                        else if (couponReference.personalized) {
                            _this.getPersonalizedCouponCodeFromApi(couponReference, market).then(function (couponCode) {
                                resolve(_this.saveCouponCodeIntoUserSession(couponReference, market, couponCode));
                            }).catch(function () {
                                resolve(_this.saveCouponCodeIntoUserSession(couponReference, market, couponReference.couponName));
                            });
                        }
                        else {
                            resolve(_this.saveCouponCodeIntoUserSession(couponReference, market, couponReference.code));
                        }
                    })];
            });
        });
    };
    CouponsSession.prototype.getPersonalizedCouponCodeFromApi = function (couponReference, market) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userSessionIdForCoupons;
            return tslib_1.__generator(this, function (_a) {
                userSessionIdForCoupons = this.getUserSessionIdForCoupons();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var protocol = store.getState().websiteState.app.location.protocol;
                        var apiUrl = settings.coreApi.prefix + settings.coreApi.endPoints.coupons;
                        try {
                            fetch(apiUrl + '?' + new URLSearchParams({
                                couponName: couponReference.couponName,
                                userSessionId: userSessionIdForCoupons,
                                market: '' + market
                            })).then(function (response) {
                                if (response.status === 200) {
                                    response.json().then(function (data) {
                                        var couponResponse = data;
                                        resolve(couponResponse.couponCode);
                                    });
                                }
                                else {
                                    console.error('Error while fetching coupon code', response.status, response);
                                    reject('');
                                }
                            }
                            // tslint:disable-next-line:no-empty
                            ).catch(function (error) {
                                reject('');
                            });
                        }
                        catch (error) {
                            console.error('Error while fetching coupon code');
                            reject('');
                        }
                    })];
            });
        });
    };
    CouponsSession.prototype.isExitIntentShownAlready = function () {
        var sessionKey = CouponsSession.KEY_FOR_EXIT_INTENT_IMPRESSION_DATE;
        var exitIntentShownAt = this.couponSessionHandler.get(sessionKey);
        if (exitIntentShownAt) {
            return isAfter(addMinutes(JSON.parse(exitIntentShownAt), 15), new Date());
        }
        return false;
    };
    CouponsSession.prototype.saveExitIntentImpressionTime = function () {
        var sessionKey = CouponsSession.KEY_FOR_EXIT_INTENT_IMPRESSION_DATE;
        this.couponSessionHandler.set(sessionKey, JSON.stringify(new Date()));
    };
    CouponsSession.prototype.getUserSessionIdForCoupons = function () {
        var sessionId = '';
        var sessionKey = CouponsSession.KEY_FOR_SESSION_ID;
        if (this.couponSessionHandler.has(sessionKey)) {
            sessionId = this.couponSessionHandler.get(sessionKey);
        }
        else {
            sessionId = uuidv4();
            this.couponSessionHandler.set(sessionKey, sessionId);
        }
        return sessionId;
    };
    CouponsSession.couponSessions = new Map();
    CouponsSession.KEY_FOR_SESSION_ID = 'coupon.sessionId';
    CouponsSession.KEY_FOR_EXIT_INTENT_IMPRESSION_DATE = 'coupon.exitIntentShownAt';
    return CouponsSession;
}());
export default CouponsSession;
